import React, { Component } from 'react';
import { 
  Card,
  CardHeader,
  CardBody,
  Button,
  ListGroup,
  ListGroupItem,
  InputGroup,
  InputGroupAddon,
  Input,
  Pagination, 
  PaginationItem, 
  PaginationLink,
  Alert
} from 'reactstrap';
import numeral from 'numeral';

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      prefectures: null,
      origPrefectures: null,
      page: null,
      totalPages: null,
      origTotalPages: null,
      noSearchResults: false
    };
  }

  componentDidMount() {
    const { index, tier } = this.props;

    if(index) {
      fetch(`/api/find_comparable_markets/comparable_markets/tier/${tier}/${index}/page/1`).then((resp) => resp.json())
        .then((respJson) => {
          this.setState({
            prefectures: respJson.data,
            origPrefectures: respJson.data,
            page: 1,
            totalPages: respJson.total_pages,
            origTotalPages: respJson.total_pages
          }); 
        });
    }
  }

  componentDidUpdate(prevProps) {
    const { index, tier } = this.props; 

    if(index && index !== prevProps.index) {
      fetch(`/api/find_comparable_markets/comparable_markets/tier/${tier}/${index}/page/1`).then((resp) => resp.json())
        .then((respJson) => {
          this.setState({
            prefectures: respJson.data,
            origPrefectures: respJson.data,
            page: 1,
            totalPages: respJson.total_pages,
            origTotalPages: respJson.total_pages
          }); 
        });
    }
  }

  handlePrevClick() {
    const { page } = this.state;
    const { index, tier } = this.props;

    fetch(`/api/find_comparable_markets/comparable_markets/tier/${tier}/${index}/page/${(page - 1)}`).then((resp) => resp.json())
      .then((respJson) => {
        this.setState({ 
          prefectures: respJson.data,
          page: page - 1,
          noSearchResults: false
        });
      });
  }

  handleNextClick() {
    const { page } = this.state;
    const { index, tier } = this.props;

    fetch(`/api/find_comparable_markets/comparable_markets/tier/${tier}/${index}/page/${(page + 1)}`).then((resp) => resp.json())
      .then((respJson) => {
        this.setState({ 
          prefectures: respJson.data,
          page: page + 1,
          noSearchResults: false
        });
      });
  }

  handleSearchChange(e) {
    if(e.target.value === "") {
      this.setState({ 
        search: e.target.value,
        prefectures: this.state.origPrefectures,
        page: 1,
        totalPages: this.state.origTotalPages,
        noSearchResults: false
      }); 
    } else {
      this.setState({ 
        search: e.target.value,
        noSearchResults: false
      }); 
    }
  }

  handleSearchClick() {
    const { index, tier } = this.props;
    const { search } = this.state;

    fetch(`/api/find_comparable_markets/comparable_markets/tier/${tier}/${index}/search/${search}`)
      .then((resp) => resp.json())
      .then((respJson) => {
        if(respJson.data.length > 0) {
          this.setState({
            prefectures: respJson.data,
            page: 1,
            totalPages: respJson.total_pages,
            noSearchResults: false
          });
        } else {
          this.setState({
            prefectures: this.state.origPrefectures,
            page: 1,
            totalPages: this.state.origTotalPages,
            noSearchResults: true
          }); 
        }
      });
  }

  render() {
    const { tier, prefecture } = this.props;

    let searchResults = [];
    if(this.state.prefectures) {
      searchResults = this.state.prefectures.map((value) => {
        return (
          <ListGroupItem key={value.id} className="d-flex justify-content-between">
            <span>{value.name}&nbsp;&nbsp;<span className="text-muted">{(numeral(value.value * value.multiplier)).format('0,0.000')} Index</span></span>
            <Button 
              color="primary" 
              tag="a"
              size="sm" 
              href={"/find_comparable_markets/tier/" + tier + "/prefecture/" + prefecture.id + "/comparable_prefecture/" + value.id}
              outline>
              Select
            </Button>
          </ListGroupItem>
        ); 
      }); 
    }

    return (
      <Card className="mb-3">
        <CardHeader className="bg-primary text-white">
          Prefectures comparable to {prefecture ? prefecture.attributes.name : null}
        </CardHeader>
        <CardBody>
          { this.state.noSearchResults ? <Alert color="danger">No search results found.</Alert> : null }
          <InputGroup>
            <Input 
              value={this.state.search}
              onChange={this.handleSearchChange.bind(this)}
              placeholder="Search prefectures" />
            <InputGroupAddon addonType="append">
              <Button 
                onClick={this.handleSearchClick.bind(this)}
                color="primary">
                Search
              </Button>
            </InputGroupAddon>
          </InputGroup>
          <hr/>
          <ListGroup>
            {searchResults}
          </ListGroup>
          <Pagination className="mt-2" listClassName="justify-content-center mb-0">
            <PaginationItem
              disabled={this.state.page === 1}>
              <PaginationLink
                onClick={this.handlePrevClick.bind(this)}>
                Previous
              </PaginationLink>
            </PaginationItem>
            <PaginationItem
              disabled={this.state.page === this.state.totalPages}>
              <PaginationLink
                onClick={this.handleNextClick.bind(this)}>
                Next
              </PaginationLink>
            </PaginationItem>
          </Pagination>
          <p className="text-center mt-2 mb-0">{this.state.page} / {this.state.totalPages}</p>
        </CardBody>
      </Card>
    );
  }
}

export default Search;
